/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/7
 */
import {combineReducers} from 'redux';
const initState = {
  userInfo: {}
};

const userInfo = (state = initState.userInfo, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default combineReducers({
  userInfo
});



// WEBPACK FOOTER //
// ./src/reducers/user.js